import { makeStyles } from '@mui/styles';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator
} from '@mui/lab';
import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import moment from 'moment';
import Pagination from '../../Pagination';
import NoDataAvailable from './NoDataAvailable';

const useStyles = makeStyles((theme) => ({
  labelTypography: {
    color: '#6F6F6F',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  valueTypography: {
    color: '#171D40',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px',
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  locationHistoryTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },

  locationHistoryAddress: {
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  },
  callButtonOnMap: {
    position: 'absolute',
    top: '70%',
    right: '3%',
    backgroundColor: 'white',
    color: 'black'
  },
  lockedStatusOnMap: {
    top: '75%',
    left: '35%',
    position: 'absolute',
    background: 'white',
    padding: '5px',
    color: 'black',
    fontSize: 14,
    borderRadius: '5px 5px'
  },
  reportButtonOnMap: {
    position: 'absolute',
    top: '70%',
    left: '3%',
    backgroundColor: 'white',
    color: 'black'
  },
  topLeftStackOnMap: {
    position: 'absolute',
    top: '27%',
    left: '3%',
    backgroundColor: 'white !important',
    color: 'black !important'
  },
  topRightStackOnMap: {
    position: 'absolute',
    top: '27%',
    right: '3%',
    backgroundColor: 'white !important',
    color: 'black !important'
  },
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export default function LocationTripHistory({
  loader,
  locationData,
  setLocationPageNumber,
  locationPageNumber,
  setDataPerPage,
  dataPerPage
}) {
  const classes = useStyles();

  const handlePage = (event, newPage) => {
    setLocationPageNumber(newPage);
  };

  const handleDataPerPage = (event) => {
    setDataPerPage(parseInt(event?.target?.value, 10));
    setLocationPageNumber(0);
  };

  return (
    <Box>
      {locationData?.data?.eventData?.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <>
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0
              }
            }}
          >
            {locationData?.data?.eventData?.map((loc, index, arr) =>
              loader ? (
                <Skeleton sx={{ width: '100%', marginBottom: '10px' }} variant="rectangular" />
              ) : (
                <TimelineItem key={loc?.id}>
                  <TimelineSeparator>
                    <TimelineDot>
                      {index === 0 || index === arr.length - 1 ? (
                        <LocationOnOutlinedIcon sx={{ color: 'black', fontSize: 12 }} />
                      ) : (
                        <FiberManualRecordIcon sx={{ color: 'black', fontSize: 12 }} />
                      )}
                    </TimelineDot>
                    {index !== arr.length - 1 && (
                      <TimelineConnector
                        sx={{
                          borderLeft: '2px dotted black',
                          height: '100%',
                          backgroundColor: '#ffffff'
                        }}
                      />
                    )}
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2 }}>
                    <Typography className={classes.locationHistoryTitle}>
                      {loc?.location || 'Unknown location'}
                    </Typography>
                    <Typography className={classes.locationHistoryAddress}>
                      {moment(loc?.createdAt).format('h:mm A, D MMM YYYY')}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              )
            )}
          </Timeline>
          {!loader && locationData?.pagination?.totalCount > 0 && (
            <Pagination
              pageNumber={locationPageNumber}
              limit={dataPerPage || 10}
              handleChangePage={handlePage}
              handleChangeRowsPerPage={handleDataPerPage}
              pageCount={locationData?.pagination?.totalCount || 0}
            />
          )}
        </>
      )}
    </Box>
  );
}
